import { onCLS, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { trackCaptureEvent } from './captureAnalytics';
import { routePattern } from '../app';

/**
 * Core Web Vitals reporting.
 *
 * The PWA had no client-side performance signal at all: a regression that made
 * the join page take four seconds to become interactive was invisible from the
 * backend, where every request still looked fast.
 *
 * Sampled per SESSION rather than per metric, so a sampled-in session reports a
 * complete set. Sampling each metric independently would produce sessions with
 * an LCP but no INP, which cannot be correlated.
 */
const SAMPLE_RATE = 0.25;

function report(metric: Metric): void {
  trackCaptureEvent('web_vital', {
    surface: 'performance',
    metric: metric.name,
    value: Math.round(metric.value),
    rating: metric.rating,
    // Route at report time — LCP/TTFB fire on the landing route, INP/CLS can
    // fire much later on a different one.
    route: routePattern(window.location.pathname),
    navigationType: metric.navigationType,
  });
}

let installed = false;

export function installWebVitals(sampleRate = SAMPLE_RATE): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  if (Math.random() >= sampleRate) return;

  // All four are delivered at most once per page (CLS/INP on visibility change),
  // so this adds a bounded handful of events per sampled session.
  onLCP(report);
  onINP(report);
  onCLS(report);
  onTTFB(report);
}

/** Test seam. */
export function __resetWebVitalsForTest(): void {
  installed = false;
}
